import React from 'react';
import Frame from "../common/Frame";
import Footer from "../common/Footer";
import {useTranslation} from "react-i18next";
import queryString from "query-string"

export function Message() {
    const { t } = useTranslation();
    // @ts-ignore
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t(queryString.parse(window.location.search)["messageKey"])}
                </h2>
                <Footer></Footer>
            </Frame>
        </div>
    );
}
